import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCustomerAuthContext } from "../commoncomponents/useCustomerAuthContext";
import API_URL from "../../api/API";

function TestCustomerLogin() {

    const navigate = useNavigate();
    const { dispatch } = useCustomerAuthContext();

    const [phone, setPhone] = useState("");
    const [dob, setDob] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const login = async (e) => {

        e.preventDefault();

        setLoading(true);
        setError("");

        try {

            const response = await fetch(
                API_URL.CUSTOMER_LOGIN,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        phone,
                        dob,
                    }),
                }
            );

            const data = await response.json();

            setLoading(false);

            if (!data.success) {
                setError(data.message || "Login failed.");
                return;
            }

            localStorage.setItem(
                "customer",
                JSON.stringify(data.customer)
            );

            dispatch({
                type: "CUSTOMER_LOGIN",
                payload: data.customer,
            });

            navigate("/customer/home");

        }
        catch (err) {

            console.error(err);

            setLoading(false);

            setError("Server error.");

        }

    };

    return (

        <div className="max-w-lg mx-auto mt-20 border rounded-lg p-8">

            <h1 className="text-3xl font-bold mb-2">
                Test Customer Login
            </h1>

            <p className="mb-8 text-gray-600">
                Temporary login using Phone Number and Date of Birth.
            </p>

            <form
                onSubmit={login}
                className="space-y-5"
            >

                <div>

                    <label className="block mb-2 font-medium">
                        Phone Number
                    </label>

                    <input
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="w-full border rounded px-4 py-2"
                        placeholder="9876543210"
                        required
                    />

                </div>

                <div>

                    <label className="block mb-2 font-medium">
                        Date of Birth
                    </label>

                    <input
                        type="date"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        className="w-full border rounded px-4 py-2"
                        placeholder="DD/MM/YYYY"
                        required
                    />

                </div>

                {error && (
                    <div className="text-red-600">
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-black text-white py-3 rounded"
                >
                    {loading ? "Logging in..." : "Login"}
                </button>

            </form>

        </div>

    );

}

export default TestCustomerLogin;